import { render, staticRenderFns } from "./infoViewDialog.vue?vue&type=template&id=c345d948&scoped=true&"
import script from "./infoViewDialog.vue?vue&type=script&lang=js&"
export * from "./infoViewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c345d948",
  null
  
)

export default component.exports